/**
 * Refreshes a <turbo-frame> by id. When frameSrc is set, assigns it and clears
 * lazy "complete"; otherwise uses reload() or reassigns the existing src.
 */
export function reloadTurboFrame(options) {
  new TurboFrameReload(options).perform()
}

class TurboFrameReload {
  #frameId
  #frameSrc

  constructor({ frameId, frameSrc = null } = {}) {
    this.#frameId = frameId
    this.#frameSrc = frameSrc
  }

  perform() {
    if (!this.#frameId) return

    const frame = document.getElementById(this.#frameId)
    if (!frame) return

    if (this.#frameSrc) {
      this.#assignCanonicalSrc(frame)
      return
    }

    if (this.#reloadViaTurbo(frame)) return

    this.#refreshSrcAttribute(frame)
  }

  #assignCanonicalSrc(frame) {
    frame.removeAttribute("complete")
    frame.src = this.#frameSrc
  }

  #reloadViaTurbo(frame) {
    if (typeof frame.reload !== "function") return false
    frame.reload()
    return true
  }

  #refreshSrcAttribute(frame) {
    const src = frame.getAttribute("src")
    if (src) frame.setAttribute("src", src)
  }
}
